import axios from "axios";
import { backendUrl } from "../../config/config";

const url = backendUrl + "/user";

const createUser = async (data) => {
  try {
    const res = await axios.post(`${url}/signup`, data);
    return res;
  }
  catch (err) {
    return err.response;
  }
}

const login = async (data) => {
  try {
    const res = await axios.post(`${url}/login`, data);
    return res;
  }
  catch (err) {
    return err.response;
  }
}

const isLoggedIn = async (data) => {
  try {
    const res = await axios.get(`${url}/is-logged-in`, data);
    return res;
  }
  catch (err) {
    return err.response;
  }
}

const logout = async () => {
  try {
    const res = await axios.get(`${url}/logout`);
    return res;
  }
  catch (err) {
    return err.response;
  }
}

const readUser = async (userId) => {
  try {
    const res = await axios.get(`${url}/read/${userId}`);
    return res;
  }
  catch (err) {
    return err.response;
  }
}

const updateUser = async (data) => {
  try {
    const res = await axios.put(`${url}/update`, data);
    return res;
  }
  catch (err) {
    return err.response;
  }
}

export {
  createUser,
  login,
  isLoggedIn,
  logout,
  readUser,
  updateUser
};